import Vue from 'vue';
import App from './App.vue';
// import Vuetify from  'vuetify'
import './plugins/vuetify';
import router from './router';
import store from '@/store';
import DEFINES from '@/defines';
//import './registerServiceWorker';
import i18n from './i18n';
import moment from 'moment';
import VueClipboard from 'vue-clipboard2';
import SocialSharing from 'vue-social-sharing';

//Sentry configuration for production env
require('@/sentry')
//Google analytics configuration for production env
require('@/analytics')

Vue.use (SocialSharing);
Vue.prototype.DEFINES = DEFINES;
Vue.config.productionTip = false;
Vue.prototype.moment = moment;
Vue.use (VueClipboard);

new Vue ({
  router,
  store,
  i18n,
  render: h => h (App),
}).$mount ('#app');
